import React, { useEffect, useState } from "react"
import dayjs from "dayjs"
import { updatePSEMachinesBatchTemperatureForAlerts } from "../../../actions/ProductionSteps/ProductionStepExecutions"
import { useDispatch } from "react-redux"
import PSEToggleFormButtons from "./alerts/PSEToggleFormButtons"
import { formatPSETemperature, PSE_BLOCK_TYPES } from "../../../utils/productionStepExecution"
import PSESection from "./section/PSESection"
import ProductionStepExecutionMachinesForm from "../productionStepExecutionInProgressCases/ProductionStepExecutionMachinesForm"

export const sx = {
	label: {
		color: "#555",
		fontSize: 14,
		fontWeight: 400,
		lineHeight: "22px"
	},
	value: {
		color: "#262626",
		fontSize: 16,
		fontWeight: 400,
		lineHeight: "24px"
	}
}

const PSECoolingRecap = ({
	pseId,
	visible = true,
	machinesBatch = [],
	isFromAlertsPage = false
}) => {
	const [isEdition, setIsEdition] = useState(false)
	const [machinesBatchValues, setMachinesBatchValues] = useState({})

	const dispatch = useDispatch()

	useEffect(() => {
		if (!isEdition) return
		machinesBatch.forEach((machineBatch, index) => {
			setMachinesBatchValues((prevValues) => {
				return {
					...prevValues,
					[index]: {
						temperature: formatPSETemperature(machineBatch, "COOLING"),
						coolingStartTime: machineBatch.coolingStartTime ? dayjs(machineBatch.coolingStartTime).format("HH:mm") : "",
						coolingEndTime: machineBatch.coolingEndTime ? dayjs(machineBatch.coolingEndTime).format("HH:mm") : "",
					}
				}
			})
		})
	}, [machinesBatch])

	if (!visible) {
		return null
	}

	const openIsEdition = () => setIsEdition(true)
	const closeIsEdition = () => {
		setIsEdition(false)
		setMachinesBatchValues({})
	}

	const handleChangeTemperatures = (index, newValue) => {
		setMachinesBatchValues((prevValues) => ({
			...prevValues,
			[index]: {
				...prevValues[index],
				...newValue
			}
		}))
	}

	const handleSubmit = async () => {
		if (!isFromAlertsPage) return
		if (!pseId) return
		await dispatch(updatePSEMachinesBatchTemperatureForAlerts(pseId, machinesBatchValues, "COOLING"))
		closeIsEdition()
	}

	return (
		<PSESection
			sectionType={PSE_BLOCK_TYPES.COOLING}
			title="Refroidissement"
			renderTopRight={() => (
				<>
					{isFromAlertsPage && (
						<div className="flexRow justifyEnd center">
							<PSEToggleFormButtons
								isEdition={isEdition}
								onSubmit={handleSubmit}
								onClose={closeIsEdition}
								onOpen={openIsEdition}
							/>
						</div>
					)}
				</>
			)}
		>
			<ProductionStepExecutionMachinesForm
				mode={PSE_BLOCK_TYPES.COOLING_END}
				machinesBatch={machinesBatch}
				handleChangeTemperatures={isEdition ? (index, newValue) => {
					handleChangeTemperatures(index, newValue)
				} : null
				}
			/>
		</PSESection>
	)

}

export default PSECoolingRecap
